'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuth = void 0;
const StripeResource_js_1 = require("../StripeResource.js");
const utils_js_1 = require("../utils.js");
const stripeMethod = StripeResource_js_1.StripeResource.method;
const oAuthHost = 'connect.stripe.com';
exports.OAuth = StripeResource_js_1.StripeResource.extend({
  basePath: '/',
  authorizeUrl(params, options) {
    params = params || {};
    options = options || {};
    let path = 'oauth/authorize';
    // For Express accounts, the path changes
    if (options.express) {
      path = "express/".concat(path);
    }
    if (!params.response_type) {
      params.response_type = 'code';
    }
    if (!params.client_id) {
      params.client_id = this._stripe.getClientId();
    }
    if (!params.scope) {
      params.scope = 'read_write';
    }
    return "https://".concat(oAuthHost, "/").concat(path, "?").concat((0, utils_js_1.stringifyRequestData)(params));
  },
  token: stripeMethod({
    method: 'POST',
    path: 'oauth/token',
    host: oAuthHost
  }),
  deauthorize(spec) {
    if (!spec.client_id) {
      spec.client_id = this._stripe.getClientId();
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return stripeMethod({
      method: 'POST',
      path: 'oauth/deauthorize',
      host: oAuthHost
    }).apply(this, [spec, ...args]);
  }
});